import React from 'react';
import { HiOutlineCheck, HiOutlineAdjustmentsHorizontal } from 'react-icons/hi2';
import { useLanguage, t } from '../../../i18n';
import './QuickFilters.css';

export default function QuickFilters({selectedFurnished, selectedRoomType = [], selectedAvailability, onFurnishedChange, onRoomTypeChange, onAvailabilityChange, showAdvanced, onToggleAdvanced}) {
  useLanguage();
  const privateRoom = selectedRoomType.includes('Private Room');
  const chips = [
    {label:'Available Now', active:selectedAvailability === 'immediate', toggle:() => onAvailabilityChange(selectedAvailability === 'immediate' ? '' : 'immediate')},
    {label:'Furnished', active:selectedFurnished === 'Yes', toggle:() => onFurnishedChange(selectedFurnished === 'Yes' ? '' : 'Yes')},
    {label:'Private Room', active:privateRoom, toggle:() => onRoomTypeChange(privateRoom ? selectedRoomType.filter(value => value !== 'Private Room') : [...selectedRoomType, 'Private Room'])},
  ];
  return <div className="bb-quick-filters" role="group" aria-label={t('Quick filters')}>
    {chips.map(chip => <button key={chip.label} type="button" className="bb-quick-filters__chip" aria-pressed={chip.active} onClick={chip.toggle}>
      {chip.active && <HiOutlineCheck aria-hidden="true" />}{t(chip.label)}
    </button>)}
    <button type="button" className="bb-quick-filters__chip bb-quick-filters__more" aria-expanded={showAdvanced} aria-controls="listing-advanced-filters" onClick={onToggleAdvanced}>
      <HiOutlineAdjustmentsHorizontal aria-hidden="true" />{t(showAdvanced ? 'Hide Advanced Filter' : 'More filters')}
    </button>
  </div>;
}
